import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-off-page-performance-list',
  templateUrl: './off-page-performance-list.component.html',
  styleUrls: ['./off-page-performance-list.component.css'],
})
export class OffPagePerformanceListComponent implements OnInit {
  performanceList: any[] = [];
  summary: any = {
    total: 0,
    excellent: 0,
    good: 0,
    watch: 0,
    poor: 0,
  };
  loading: boolean = true;
  modalTitle: string = '';
  modalContent: string | null = null;
  modalListItems: any[] | null = null;


  displayedColumns: string[] = [
    'campaign',
    'keyword',
    'url',
    'prospects',
    'published',
    'backlinks',
    'referringDomains',
    'positionDelta',
    'clicksDelta',
    'impactScore',
    'health',
    'confidence',
    'lastSnapshot',
    'actions',
  ];

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/observability/seo/metricsDaily',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/observability/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/observability/social',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'MEDIAROOM',
      route: '/observability/mediaroom',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'LOGISTICS',
      route: '/observability/logistics',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-receipt',
      bgClass: 'bg-white',
      desc: 'ACCOUNTING',
      route: '/observability/accounting',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-coins',
      bgClass: 'bg-white',
      desc: 'FINANCE',
      route: '/observability/finance',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'HR',
      route: '/observability/hr',
    },
  ];

  constructor(private dataService: DataService) {}

  ngOnInit(): void {
    this.loadPerformance();
  }

  loadPerformance(): void {
    this.loading = true;
    this.dataService.getData('offPageAttribution/performance').subscribe({
      next: (res) => {
        console.log('res attr', res);
        if (res.rst) {
          this.performanceList = res.data;
          this.calculateSummary();
        }
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  calculateSummary(): void {
    this.summary = {
      total: this.performanceList.length,
      excellent: this.performanceList.filter(
        (p) => p.healthStatus === 'excellent',
      ).length,
      good: this.performanceList.filter((p) => p.healthStatus === 'good')
        .length,
      watch: this.performanceList.filter((p) => p.healthStatus === 'watch')
        .length,
      poor: this.performanceList.filter((p) => p.healthStatus === 'poor')
        .length,
    };
  }

  runAttribution(): void {
    this.loading = true;
    this.dataService.postData('offPageAttribution/run', {}).subscribe({
      next: (res) => {
        if (res.rst) {
          this.loadPerformance();
        } else {
          this.loading = false;
        }
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  showModal(title: string, content: string | any[]) {
    this.modalTitle = title;
    if (Array.isArray(content)) {
      this.modalListItems = content;
      this.modalContent = null;
    } else {
      this.modalContent = content;
      this.modalListItems = null;
    }
  }

  closeModal() {
    this.modalContent = null;
    this.modalListItems = null;
  }

  getKeywords(element: any): string[] {
    if (!element) return [];

    // Prioritize keywords stored in the performance record itself
    if (element.targetKeywords && Array.isArray(element.targetKeywords) && element.targetKeywords.length > 0) {
      return element.targetKeywords;
    }

    // Fallback to campaign suggestedKeywords (logic mirrored from campaign list)
    const campaign = element.campaignId;
    if (!campaign || !campaign.suggestedKeywords) return [];

    if (Array.isArray(campaign.suggestedKeywords)) {
      return campaign.suggestedKeywords;
    } else if (typeof campaign.suggestedKeywords === 'string') {
      return campaign.suggestedKeywords
        .split(',')
        .map((s: string) => s.trim())
        .filter(Boolean);
    } else if (typeof campaign.suggestedKeywords === 'object') {
      const kws: string[] = [];
      if (Array.isArray(campaign.suggestedKeywords.shortTerm))
        kws.push(...campaign.suggestedKeywords.shortTerm);
      if (Array.isArray(campaign.suggestedKeywords.mediumTerm))
        kws.push(...campaign.suggestedKeywords.mediumTerm);
      if (Array.isArray(campaign.suggestedKeywords.longTerm))
        kws.push(...campaign.suggestedKeywords.longTerm);
      return kws.filter(Boolean);
    }
    return [];
  }
}

